(function () {
  "use strict";

  if (window.__auCartLoaded) return;
  window.__auCartLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var CART_URL = (ROOT + "cart").replace("//", "/");
  var CART_JS = CART_URL + ".js";
  var TOGGLE = ".header--cart, .header--cart-toggle, [data-rebuy-cart-toggle], [data-drawer-view='cart-drawer']";
  var PRIMARY = ".product-buy-buttons--primary";
  var BUSY = ".product-buy-buttons--primary, .product-buy-buttons--buy-now";
  var TEXT = ".product-buy-buttons--cta-text";
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var REBUY_WAIT_MS = 5000;
  var FRESH_CART_WAIT_MS = 1500;
  var OPEN_BACKSTOP_MS = 2000;
  var DRAWER_WATCH_MS = 3000;
  var ADD_CEILING_MS = 8000;
  var PENDING_MAX_MS = 6000;
  var REBUY_RETRY_MS = 2500;
  var VIEW_CART_SETTLE_MS = 2000;
  var CHECKOUT_REPEAT_MS = 2000;
  var IDLE_SYNC_MS = 300;
  var CHECKOUT = ".rebuy-cart__checkout-button, [name='checkout']";
  var checkoutAt = -Infinity;
  var refusable = null;

  var loadedAt = Date.now();
  var onCartPage = location.pathname.replace(/\/$/, "") === CART_URL;

  function noop() {}

  function rebuy() {
    return window.Rebuy && window.Rebuy.SmartCart ? window.Rebuy : null;
  }

  function rebuyCart() {
    try {
      return window.Rebuy.Cart.getCart() || null;
    } catch (_) {
      return null;
    }
  }

  function pushDL(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (_) {}
  }

  function clarity(key, value) {
    try {
      if (typeof window.clarity === "function") window.clarity("set", key, value);
    } catch (_) {}
  }

  var redirected = false;
  function goToCart(reason) {
    if (redirected || onCartPage) return;
    redirected = true;
    pushDL({ event: "au_cart_fallback", au_fallback_reason: reason });
    clarity("au-cart-fallback", reason);
    window.location.assign(CART_URL);
  }

  var pendingShow = false;
  var pendingTimer = 0;
  var lastShowAt = 0;
  var shownAt = 0;
  var drawerWatch = 0;

  function drawerVisible() {
    var dialog = document.getElementById("rebuy-cart");
    return !!dialog && dialog.getAttribute("aria-hidden") === "false";
  }

  function show() {
    var R = rebuy();
    if (!R) {
      if (Date.now() - loadedAt >= REBUY_WAIT_MS) return goToCart("rebuy-unavailable");
      if (pendingShow) return;
      pendingShow = true;
      pendingTimer = setTimeout(function () {
        if (pendingShow) rebuy() ? show() : goToCart("rebuy-timeout");
      }, REBUY_WAIT_MS);
      return;
    }
    pendingShow = false;
    clearTimeout(pendingTimer);
    var now = Date.now();
    if (now - lastShowAt < 750) return;
    lastShowAt = now;
    try {
      R.SmartCart.show();
    } catch (_) {
      return goToCart("show-threw");
    }
    clearTimeout(drawerWatch);
    drawerWatch = setTimeout(function () {
      if (shownAt < now && !drawerVisible()) goToCart("drawer-never-opened");
    }, DRAWER_WATCH_MS);
  }

  var readyTries = 0;
  function onRebuyReady() {
    if (window.__RebuyReady) return;
    if (!rebuy()) {
      if (readyTries++ < 20) setTimeout(onRebuyReady, 250);
      return;
    }
    window.__RebuyReady = true;
    var queue = window.__auCartQueueStats;
    var wroteBeforeReady = !!(queue && queue.queued);
    if (pendingShow && wroteBeforeReady) openWithFreshCart();
    else if (pendingShow || onCartPage) show();
    if (wroteBeforeReady && !pendingShow) refreshRebuyCart().catch(noop);
    if (!paintCount(rebuyCart()) && !bootFetched) window.__auGetCart().then(paintCount, noop);
  }

  window.__auGetCart = function () {
    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, 10000);
    return fetch(CART_JS, {
      headers: { "Cache-Control": "no-cache" },
      credentials: "same-origin",
      signal: controller.signal,
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart.js HTTP " + res.status);
        return res.json();
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== "number" || !Array.isArray(cart.items)) {
          throw new Error("cart.js returned malformed payload");
        }
        return cart;
      })
      .finally(function () {
        clearTimeout(timer);
      });
  };

  function refreshRebuyCart() {
    var rc = window.Rebuy && window.Rebuy.Cart;
    if (!rc || typeof rc.fetchShopifyCart !== "function") return window.__auGetCart();
    return new Promise(function (resolve) {
      var done = false;
      var finish = function (cart) {
        if (done) return;
        done = true;
        resolve(cart);
      };
      rc.fetchShopifyCart(finish);
      setTimeout(function () {
        if (!done) rc.fetchShopifyCart(finish);
      }, REBUY_RETRY_MS);
    });
  }

  var pendingCap = 0;
  function setCartPending(on) {
    clearTimeout(pendingCap);
    var dialog = document.getElementById("rebuy-cart");
    if (on) {
      document.documentElement.setAttribute("data-au-cart-pending", "");
      if (dialog) dialog.setAttribute("aria-busy", "true");
      pendingCap = setTimeout(setCartPending, PENDING_MAX_MS, false);
    } else {
      document.documentElement.removeAttribute("data-au-cart-pending");
      if (dialog) dialog.removeAttribute("aria-busy");
    }
  }

  var addStartedAt = 0;
  function reportCartOpen(label) {
    if (!addStartedAt) return;
    var ms = Math.round(performance.now() - addStartedAt);
    addStartedAt = 0;
    (window.__auCartOpenMs = window.__auCartOpenMs || []).push(ms);
    clarity("au_cart_open", label || (ms < 1000 ? "<1s" : ms < 1500 ? "1-1.5s" : ms < 2000 ? "1.5-2s" : ms < 3000 ? "2-3s" : "3s+"));
  }

  function openWithFreshCart() {
    var opened = false;
    var open = function () {
      if (opened) return;
      opened = true;
      clearTimeout(fallback);
      show();
    };
    var fallback = setTimeout(function () {
      var cart = rebuyCart();
      if (!cart || !cart.item_count) setCartPending(true);
      open();
    }, FRESH_CART_WAIT_MS);
    refreshRebuyCart().then(
      function (cart) {
        reportCartOpen();
        if (!cart || !cart.item_count) setCartPending(true);
        open();
      },
      function () {
        reportCartOpen("read-failed");
        open();
      },
    );
  }

  function openFromToggle(e) {
    if (!e.target || !e.target.closest || !e.target.closest(TOGGLE)) return;
    e.preventDefault();
    e.stopPropagation();
    show();
    if (rebuy()) refreshRebuyCart().catch(noop);
  }

  document.addEventListener("click", openFromToggle, true);
  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var t = e.target;
      if (!t || t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      openFromToggle(e);
    },
    true,
  );

  window.addEventListener(
    "theme:cart:open",
    function (e) {
      try {
        e.stopImmediatePropagation();
        e.preventDefault();
      } catch (_) {}
      openWithFreshCart();
    },
    true,
  );

  if (!customElements.get("cart-drawer")) {
    customElements.define(
      "cart-drawer",
      class extends HTMLElement {
        renderContents() {}
        open() {
          openWithFreshCart();
        }
      },
    );
    var mountShim = function () {
      if (document.querySelector("cart-drawer") || !document.body) return;
      var el = document.createElement("cart-drawer");
      el.hidden = true;
      el.setAttribute("aria-hidden", "true");
      document.body.appendChild(el);
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mountShim, { once: true });
    else mountShim();
  }

  function syncBeyondBasket(cart) {
    var BeyondCart = window.customElements && window.customElements.get("cart-element");
    if (BeyondCart && typeof BeyondCart.fillBasket === "function") BeyondCart.fillBasket(cart.items);
  }

  function paintCount(cart) {
    if (!cart || typeof cart.item_count !== "number") return false;
    document.querySelectorAll(TOGGLE).forEach(function (el) {
      el.setAttribute("data-cart-count", cart.item_count);
    });
    if (Array.isArray(cart.items)) syncBeyondBasket(cart);
    return true;
  }

  var bootFetched = false;
  var counter = document.querySelector(TOGGLE);
  if (!paintCount(rebuyCart()) && !(counter && /^\d+$/.test(counter.getAttribute("data-cart-count") || ""))) {
    bootFetched = true;
    window.__auGetCart().then(paintCount, noop);
  }

  var cartPageSignature = null;
  function cartSignature(cart) {
    return [cart.item_count, cart.total_price].concat(
      (cart.items || []).map(function (item) {
        return item.key + ":" + item.quantity;
      }),
    ).join("|");
  }

  document.addEventListener("rebuy:cart.change", function (e) {
    var cart = e && e.detail && e.detail.cart && e.detail.cart.cart;
    if (paintCount(cart)) {
      if (cart.item_count > 0) setCartPending(false);
    } else if (!paintCount(rebuyCart())) {
      window.__auGetCart().then(paintCount, noop);
    }
    var current = cart || rebuyCart();
    if (onCartPage && current && typeof window.trigger === "function") {
      var signature = cartSignature(current);
      if (cartPageSignature !== null && signature !== cartPageSignature) {
        try {
          window.trigger("theme:cart:refresh");
        } catch (_) {}
      }
      cartPageSignature = signature;
    }
  });


  ["rebuy.loaded", "rebuy:cart.ready", "rebuy:smartcart.ready"].forEach(function (name) {
    document.addEventListener(name, onRebuyReady);
  });
  onRebuyReady();

  var lastOutsideFocus = null;
  var returnFocus = null;
  document.addEventListener("focusin", function (e) {
    var dialog = document.getElementById("rebuy-cart");
    if (!dialog || !dialog.contains(e.target)) lastOutsideFocus = e.target;
  });

  function focusWithoutScroll(options) {
    HTMLElement.prototype.focus.call(this, Object.assign({}, options, { preventScroll: true }));
  }

  function focusDrawer() {
    var dialog = document.getElementById("rebuy-cart");
    if (!dialog || dialog.contains(document.activeElement)) return;
    returnFocus = lastOutsideFocus;
    if (!dialog.hasAttribute("tabindex")) dialog.setAttribute("tabindex", "-1");
    dialog.focus = focusWithoutScroll;
    try {
      dialog.focus();
    } catch (_) {}
  }

  function setOnce(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function ensureDrawerName() {
    var dialog = document.getElementById("rebuy-cart");
    if (!dialog) return;
    dialog.querySelectorAll("h4.primary-title").forEach(function (h) {
      setOnce(h, "role", "heading");
      setOnce(h, "aria-level", "2");
    });
    dialog.querySelectorAll("h5.rebuy-product-title").forEach(function (h) {
      setOnce(h, "role", "heading");
      setOnce(h, "aria-level", "3");
    });
    dialog.querySelectorAll(".rebuy-button[aria-label]").forEach(function (button) {
      var visible = button.textContent.replace(/\s+/g, " ").trim();
      var label = button.getAttribute("aria-label") || "";
      if (visible && label.toLowerCase().indexOf(visible.toLowerCase()) === -1) button.setAttribute("aria-label", visible + ". " + label);
    });
    var labelledBy = dialog.getAttribute("aria-labelledby");
    var label = labelledBy && document.getElementById(labelledBy);
    if (label && label.textContent.trim()) return;
    var title = dialog.querySelector(".rebuy-cart__title, .cdh-empty-title");
    if (title && title.textContent.trim()) {
      title.id = "rebuy-cart-title";
      dialog.setAttribute("aria-labelledby", title.id);
      dialog.removeAttribute("aria-label");
      return;
    }
    var close = dialog.querySelector(".rebuy-cart__flyout-close");
    var fallback = close && close.getAttribute("aria-label");
    fallback = fallback ? fallback.replace(/^close\s+/i, "").trim() : "";
    dialog.removeAttribute("aria-labelledby");
    dialog.setAttribute("aria-label", fallback || "Cart");
  }

  var semantics = null;
  var semanticsFrame = null;
  function observeDrawerSemantics() {
    if (semantics) semantics.disconnect();
    var dialog = document.getElementById("rebuy-cart");
    if (!dialog) return;
    semantics = new MutationObserver(function () {
      if (semanticsFrame !== null) return;
      semanticsFrame = requestAnimationFrame(function () {
        semanticsFrame = null;
        ensureDrawerName();
      });
    });
    semantics.observe(dialog, { childList: true, subtree: true });
  }

  function stopDrawerSemantics() {
    if (semantics) semantics.disconnect();
    semantics = null;
    if (semanticsFrame !== null) cancelAnimationFrame(semanticsFrame);
    semanticsFrame = null;
  }

  function itemPayload(item) {
    if (!item) return {};
    return {
      item_id: item.product_id || item.id,
      item_variant_id: item.variant_id || item.id,
      item_name: item.title || item.product_title,
      item_variant: item.variant_title,
      price: typeof item.price === "number" ? item.price / 100 : undefined,
      quantity: item.quantity,
    };
  }

  function impressionPayload(item, index) {
    return {
      id: item.sku || String(item.product_id || item.id || ""),
      name: item.product_title || item.title,
      brand: item.vendor,
      category: "",
      variant: item.variant_title,
      price: typeof item.price === "number" ? (item.price / 100).toFixed(2) : undefined,
      position: index + 1,
      product_id: String(item.product_id || ""),
      variant_id: String(item.variant_id || item.id || ""),
      quantity: item.quantity,
    };
  }

  function pushViewCart(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
    pushDL({
      event: "dl_view_cart",
      source: "rebuy",
      cart_total: typeof cart.total_price === "number" ? (cart.total_price / 100).toFixed(2) : undefined,
      ecommerce: {
        currencyCode: cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || undefined,
        actionField: { list: "Shopping Cart" },
        impressions: cart.items.map(impressionPayload),
      },
    });
  }

  var viewCartTimer = null;
  document.addEventListener("rebuy:smartcart.show", function () {
    shownAt = Date.now();
    clearTimeout(drawerWatch);
    revertAll();
    var shown = rebuyCart();
    if (!shown || !shown.item_count) {
      refreshRebuyCart().then(function (cart) {
        if (cart && cart.item_count) clarity("au-cart-heal", "empty-drawer");
      }, noop);
    }
    ensureDrawerName();
    requestAnimationFrame(function () {
      ensureDrawerName();
      observeDrawerSemantics();
      focusDrawer();
    });
    pushDL({ event: "rebuy_smartcart_show", source: "rebuy" });
    clearTimeout(viewCartTimer);
    viewCartTimer = setTimeout(function () {
      var cart = rebuyCart();
      if (cart && Array.isArray(cart.items)) return pushViewCart(cart);
      window.__auGetCart().then(pushViewCart, noop);
    }, VIEW_CART_SETTLE_MS);
  });

  document.addEventListener("rebuy:smartcart.hide", function () {
    stopDrawerSemantics();
    var target = returnFocus;
    returnFocus = null;
    requestAnimationFrame(function () {
      var dialog = document.getElementById("rebuy-cart");
      var active = document.activeElement;
      var lost = !active || active === document.body || (dialog && dialog.contains(active));
      if (lost && target && target.isConnected) {
        try {
          target.focus({ preventScroll: true });
        } catch (_) {}
      }
    });
    pushDL({ event: "rebuy_smartcart_hide", source: "rebuy" });
  });

  [
    ["rebuy:smartcart.line-item-increase", { event: "rebuy_smartcart_line_item_increase" }],
    ["rebuy:smartcart.line-item-decrease", { event: "remove_from_cart", reason: "quantity_decrease" }],
    ["rebuy:smartcart.line-item-removed", { event: "remove_from_cart" }],
  ].forEach(function (pair) {
    document.addEventListener(pair[0], function (e) {
      var item = e && e.detail && e.detail.item;
      pushDL(Object.assign({}, pair[1], { source: "rebuy", ecommerce: { items: [itemPayload(item)] } }));
    });
  });

  document.addEventListener("rebuy:cart.add", function (e) {
    var items = e && e.detail && e.detail.item;
    if (!items) return;
    pushDL({
      event: "add_to_cart",
      source: "rebuy_cart",
      ecommerce: { items: (Array.isArray(items) ? items : [items]).map(itemPayload) },
    });
  });

  document.addEventListener("rebuy.add", function (e) {
    var detail = (e && e.detail) || {};
    pushDL({
      event: "rebuy_widget_add",
      source: "rebuy_widget",
      widget_id: detail.widget && detail.widget.id,
      ecommerce: { items: [itemPayload(detail.product || detail.item)] },
    });
  });

  var timers = new WeakMap();
  var inFlight = new WeakSet();
  var busyObservers = new WeakMap();

  function formOf(btn) {
    return btn && btn.closest ? btn.closest("form") : null;
  }

  function variantId(btn) {
    var input = formOf(btn) && formOf(btn).querySelector('[name="id"]');
    var val = input && (input.value || input.getAttribute("value"));
    return val ? String(val).trim() : null;
  }

  function later(btn, ms, fn) {
    clearTimeout(timers.get(btn));
    timers.set(btn, setTimeout(fn, ms));
  }

  function setAdding(btn) {
    if (!btn || btn.dataset.auState === "adding") return;
    clearErrors(btn);
    var span = btn.querySelector(TEXT);
    if (span) span.textContent = btn.getAttribute("data-text") === "Pre-order" ? "ORDERING..." : "ADDING...";
    btn.dataset.auState = "adding";
    btn.setAttribute("aria-busy", "true");
    btn.setAttribute("aria-disabled", "true");
    if (!busyObservers.has(btn)) {
      var mo = new MutationObserver(function () {
        if (btn.dataset.auState !== "adding" || btn.getAttribute("aria-busy") !== "false") return;
        btn.setAttribute("aria-busy", "true");
      });
      mo.observe(btn, { attributes: true, attributeFilter: ["aria-busy"] });
      busyObservers.set(btn, mo);
    }
    later(btn, ADD_CEILING_MS, resolveStall.bind(null, btn));
  }

  function revert(btn) {
    var span = btn.querySelector(TEXT);
    if (span) span.textContent = btn.getAttribute("data-text") || "ADD TO CART";
    delete btn.dataset.auState;
    btn.setAttribute("aria-busy", "false");
    btn.removeAttribute("aria-disabled");
    var form = formOf(btn);
    if (form) inFlight.delete(form);
    clearTimeout(timers.get(btn));
    timers.delete(btn);
  }

  function revertAll() {
    eachAdding(revert);
  }

  function eachAdding(fn) {
    document.querySelectorAll(PRIMARY).forEach(function (btn) {
      if (btn.dataset.auState === "adding") fn(btn);
    });
  }

  function clearErrors(btn) {
    var root = btn.closest(".product-buy-buttons--root") || btn.parentNode;
    if (!root) return;
    root.querySelectorAll("[data-au-atc-error]").forEach(function (box) {
      box.hidden = true;
    });
  }

  function errorBox(btn) {
    var bar = btn.closest(".product-buy-buttons--drawer");
    if (bar && bar.getAttribute("aria-hidden") !== "false") bar = null;
    var host = bar || btn.closest(".product-buy-buttons--root") || btn.parentNode;
    if (!host) return;
    var box = host.querySelector(":scope > [data-au-atc-error]");
    if (!box) {
      box = document.createElement("p");
      box.setAttribute("data-au-atc-error", "");
      box.setAttribute("role", "alert");
      box.className = "au-atc__error";
      if (bar) {
        host.insertBefore(box, btn);
        new MutationObserver(function () {
          if (bar.getAttribute("aria-hidden") === "true") box.hidden = true;
        }).observe(bar, { attributes: true, attributeFilter: ["aria-hidden"] });
      } else {
        host.appendChild(box);
      }
    }
    box.textContent = "Sorry, we could not add that to your cart. It may have just sold out.";
    box.hidden = false;
  }

  function failAdd(btn) {
    revert(btn);
    errorBox(btn);
  }

  function resolveStall(btn) {
    if (btn.dataset.auState !== "adding") return;
    var queue = window.__auCartQueueStats;
    if (queue && queue.addsPending) return later(btn, ADD_CEILING_MS, resolveStall.bind(null, btn));
    var wanted = variantId(btn);
    window.__auGetCart()
      .then(function (cart) {
        return cart.items.some(function (li) {
          return String(li.variant_id) === wanted;
        });
      })
      .catch(function () {
        return false;
      })
      .then(function (present) {
        if (btn.dataset.auState !== "adding") return;
        if (present) openWithFreshCart();
        else failAdd(btn);
      });
  }

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.action || !ADD_RE.test(form.action)) return;
      if (inFlight.has(form)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var btn = e.submitter && e.submitter.matches && e.submitter.matches(PRIMARY) ? e.submitter : form.querySelector(PRIMARY);
      if (!btn) return;
      inFlight.add(form);
      setAdding(btn);
      refusable = btn;
      setTimeout(function () {
        refusable = null;
      }, 0);
    },
    true,
  );

  document.addEventListener(
    "click",
    function (e) {
      var t = e.target;
      if (!(t && t.closest && (inFlight.has(formOf(t.closest(PRIMARY))) || t.closest('product-quick-add[aria-busy="true"]')))) return;
      e.preventDefault();
      e.stopPropagation();
    },
    true,
  );

  document.addEventListener(
    "click",
    function (e) {
      if (!(e.target && e.target.closest && e.target.closest(CHECKOUT))) return;
      var now = performance.now();
      if (now - checkoutAt < CHECKOUT_REPEAT_MS) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      checkoutAt = now;
    },
    true,
  );

  document.addEventListener("au:cart:add-settled", function (e) {
    var d = (e && e.detail) || {};
    addStartedAt = d.ok && d.startedAt ? d.startedAt : 0;
    eachAdding(function (btn) {
      var wanted = variantId(btn);
      if (d.id && wanted && wanted !== String(d.id)) return;
      if (!d.ok) return failAdd(btn);
      later(btn, OPEN_BACKSTOP_MS, function () {
        if (btn.dataset.auState === "adding") openWithFreshCart();
        later(btn, ADD_CEILING_MS, revert.bind(null, btn));
      });
    });
  });

  window.addEventListener("theme:feedback:trigger", function (e) {
    if (e.detail && e.detail.type === "quantity" && refusable) revert(refusable);
  });

  function clearBusy() {
    revertAll();
    clearTimeout(drawerWatch);
    document.querySelectorAll(BUSY).forEach(function (btn) {
      if (btn.getAttribute("aria-busy") !== "false") btn.setAttribute("aria-busy", "false");
      btn.removeAttribute("aria-disabled");
    });
  }

  document.addEventListener("au:cart:stale", function () {
    refreshRebuyCart().then(paintCount, noop);
  });

  var idleTimer = 0;
  document.addEventListener("au:cart:idle", function () {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      if (rebuy()) refreshRebuyCart().catch(noop);
    }, IDLE_SYNC_MS);
  });

  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    redirected = false;
    checkoutAt = -Infinity;
    clearBusy();
    inFlight = new WeakSet();
    refreshRebuyCart().then(paintCount, noop);
  });

  window.addEventListener("pagehide", clearBusy);
})();
